<template>
  <div class="page_register">
    <page-header/>
    <router-view v-if="show" />
    <page-footer/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageHeader from '@/containers/page-header'
import PageFooter from '@/containers/page-footer'
export default {
  name: 'Layout',
  computed: {
    ...mapGetters([
      'uid'
    ])
  },
  components: {
    PageHeader,
    PageFooter
  },
  data() {
    return {
      show: false,
      userId: null
    }
  },
  created() {
    this.$store.dispatch('GetUid')
    this.userId = parseInt(this.$route.params.id)
    if (!this.uid ) {
      this.$message.error('请先登录')
      this.$router.push({
        name: 'Login',
        params: { from: 'home' }
      })
    } else {
      this.show = true
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/Layout/register.vue